import { apiDelete, apiGet, apiPut } from '@api/api.utils'
import { IResponseCommon } from "../common.types"
import { IResponsePrintDiplomasCard, IResponsePrintDiplomasList } from "./api.types"


const route = '/printingDiplomas'


/** Список анкет */
export const getPrintingDiplomasList = (pageNumber: number, search?: string, signal?: AbortSignal): Promise<IResponsePrintDiplomasList> =>
    apiGet<IResponsePrintDiplomasList>(`${route}/getPrintingDiplomasList`, { params: { pageNumber, search }, signal })

/** Данные по анкете */
export const getPrintingDiplomasCard = (printID: number): Promise<IResponsePrintDiplomasCard> =>
    apiGet<IResponsePrintDiplomasCard>(`${route}/getPrintingDiplomasCard`, { params: { printID } })

/** Сохранение данных по анкете */
export const setPrintingDiplomasCardSave = (
    printID: number,
    printStatusID: number,
    diplomRegNumber: string,
    diplomNumber: string,
    diplomDateIssue: string
): Promise<IResponseCommon> =>
    apiPut<IResponseCommon>(`${route}/setPrintingDiplomasCardSave`, {
        params: { printID, printStatusID, diplomRegNumber, diplomNumber, diplomDateIssue },
    })



/** Удаление анкеты из раздела печати */
export const setPrintingDiplomasDelete = (printID: number): Promise<IResponseCommon> =>
    apiDelete<IResponseCommon>(`${route}/setPrintingDiplomasDelete`, { params: { printID } })